export default "__VITE_ASSET__CBl$zjQF__"